import React, { useState, useEffect } from "react";

import { Formik } from "formik";
import * as Yup from "yup";
import { Button, DialogTitle, DialogContent, Dialog, Typography } from "@mui/material";
import AutocompleteAccount from "./AutocompleteAccount";
import { LoadButton } from "app/components/Content/CustomLoadButton";
import { getIbAccount, changeIbAccount } from "app/services/SettingService";
import SuccessDisplay from "app/components/Content/SuccessDisplay";
import ErrorDisplay from "app/components/Content/ErrorDisplay";


const validationSchema = Yup.object().shape({
     account: Yup.string().required("Le choix du compte interne est obligatoire"),
})
const SettingIbAccount = () => {
     const [initialValues, setInitialValues] =useState( {
          account: ""
     })

     const [loading, setLoading] = useState(false); //loading for elastic search 
     const [success, setSuccess] = useState(false);
     const [error, setError] = useState(false);
     const [messageError, setMessageError] = useState("");

     const [openValidation, setOpenValidation] = useState(false);
     const handleOpen = () => setOpenValidation(true);
     const handleClose = () => setOpenValidation(false);

     const handleFormSubmit = (values, action) => {
          setLoading(true);
          setSuccess(false);
          try {
               changeIbAccount(values.account).then((res)=>{
                    setLoading(false);
                    setSuccess(true);
                    setError(false);
                    handleClose();
                    action.resetForm({ values: initialValues });  
                    IbAccount();
               });
          } catch (e) {
               setMessageError(e.response.data.message)
               setLoading(false);
               setError(true);
               handleClose();
          }
     }
     
     const IbAccount=()=>{
          getIbAccount().then((res)=>{
               setInitialValues({account:res.data.data.value});
          }).catch((ex)=>console.error(ex));
     } 
     useEffect(()=> {
          IbAccount();
     },[])
     return (
          <>
               <SuccessDisplay open={success} setOpen={setSuccess} message="Changement réussi" />

               <Formik
                    onSubmit={handleFormSubmit}
                    validationSchema={validationSchema}
                    initialValues={initialValues}
                    method="POST"
                    enableReinitialize
               >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                         <form onSubmit={handleSubmit}>
                              <Typography>
                                   Compte interne: {values.account}
                              </Typography>
                              <br />
                              <AutocompleteAccount errors={errors} touched={touched} handleBlur={handleBlur} name="account" handleChange={handleChange} value={values.account} autoLabel="Client" />

                              <Button color="primary" variant="contained" onClick={handleOpen} sx={{ mt: 2, mx: 1 }}>Changer compte interne</Button>
                              <Dialog onClose={handleClose} aria-labelledby="form-dialog-title" open={openValidation}>
                                   <DialogContent dividers>
                                        <DialogTitle id="form-dialog-title" onClose={handleClose} component="div">
                                             Etes-vous sûr de vouloir changer le compte interne du CBS(celui qui encaissera les frais et paiera les commissions)?
                                        </DialogTitle>
                                        <div style={{ display: "flex" }}>
                                             <LoadButton loading={loading} onClick={handleSubmit} >Valider</LoadButton>

                                             <Button color="error" variant="contained" sx={{ my: 2, marginLeft: "auto" }} onClick={handleClose}>Annuler</Button>
                                        </div>
                                   </DialogContent>
                              </Dialog>
                              <ErrorDisplay error={error} messageError={messageError} />

                         </form>
                    )}
               </Formik>
          </>

     )
}
export default SettingIbAccount;
